<template>
  <component-wrapper class="price-list-fi">
    <grid-container-fi>
      <div class="fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12">
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="isEditMode && fields.headline"
          class="price-list-fi__heading"
          v-html="fields.headline.editable"
        />
        <!-- eslint-enable vue/no-v-html -->
        <div
          v-if="!isEditMode && fields?.headline?.value"
          class="price-list-fi__heading"
        >
          {{ fields.headline.value }}
        </div>

        <div class="price-list-fi__items">
          <price-list-item-fi
            v-for="(priceListItem, index) in priceListItems"
            :key="`item${index}`"
            :fields="priceListItem.fields"
          />
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import PriceListItemFi from 'components/price-list-item-fi/PriceListItemFi';

export default {
  name: 'PriceListFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    PriceListItemFi,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    priceListItems() {
      return this.fields?.priceListItems;
    },
  },
};
</script>

<style scoped lang="scss">
@import './price-list-fi';
</style>
